<template>
    <DCard
        padding
    >
        <Form
            :product-id="productId"
            :product-plan="productPlan"
            :errors="errors"
            :runtimes="runtimes"
            :market-regions="marketRegions"
            :target-options="targetOptions"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Products/ProductPlans/Form'

export default {
    name: 'ProductPlanUpdate',
    components: {
        Form
    },
    props: {
        productId: {
            type: Number,
            default: 0
        },
        productPlan: {
            type: Object,
            default () {
                return {}
            }
        },
        runtimes: {
            type: Array,
            default () {
                return []
            }
        },
        errors: {
            type: Object,
            default () {
                return {}
            }
        },
        marketRegions: {
            type: Array,
            default () {
                return []
            }
        },
        targetOptions: {
            type: Array,
            default () {
                return []
            }
        }
    },
    methods: {
        submitData (form) {
            form.put(this.$route('products.products.plans.update', {
                product: this.productId,
                plan: this.productPlan.id
            }), {
                preserveScroll: true
            })
        }
    }
}
</script>
